import { ResponseTime } from 'src/types';

export const setDecimal = (data: ResponseTime[]) => {
    const maxDuration = data.reduce((acc, time) => {
      if(time.duration > acc) {
        acc = time.duration;
      }
      return acc;
    }, 0);
    return maxDuration > 1.5 ? false : true;
  }


// WEBPACK FOOTER //
// ./src/components/ChartCard/utils/setDecimal.ts